/**
 * Created by Bowen on 06/10/2019.
 * Description: change liveware name
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { SubChromeActionTypes } from '../actions/sub-chrome-name.action';
import { BlastEmailService } from '../../tamalelibs/services/blastemail.service';

@Injectable()
export class SubChromeNameEffects {
    constructor(
        private _actions$: Actions,
        private _blastEmailService: BlastEmailService
    ) { }

    updateSubChromeNameEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(SubChromeActionTypes.CHANGE_LIVEWIRE_SUBCHORME_NAME),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._blastEmailService.updateLivewireName(payload).pipe(
                map(response => {
                    if (response.result === 'success') {
                        return ({
                            type: SubChromeActionTypes.CHANGE_LIVEWIRE_SUBCHORME_NAME_SUCCESS,
                            payload: payload,
                        });
                    } else {
                        return ({
                            type: SubChromeActionTypes.CHANGE_LIVEWIRE_SUBCHORME_NAME_FAILED,
                            payload: response.result,
                        });
                    }
                }),
                catchError(err => {
                    return of({
                        type: SubChromeActionTypes.CHANGE_LIVEWIRE_SUBCHORME_NAME_FAILED,
                        payload: err.message
                    });
                })
            );
        })
    ));

    getSubChromeNameEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(SubChromeActionTypes.GET_LIVEWIRE_SUBCHORME_NAME),
        switchMap(() => {
            return this._blastEmailService.getLivewireName().pipe(
                map(response => {
                    return {
                        type: SubChromeActionTypes.GET_LIVEWIRE_SUBCHORME_NAME_SUCCESS,
                        payload: response,
                    };
                }),
                catchError(err => {
                    return of({
                        type: SubChromeActionTypes.GET_LIVEWIRE_SUBCHORME_NAME_FAILED,
                        payload: err.message,
                    });
                })
            );
        })
    ));
}
